module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Solicitudes de permiso por aprobar Recursos Humanos")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.mostrarConfirmacionAprobar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionAprobar = false
      },
      "do": _vm.aprobar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea aprobar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Aprobando...")] : [_vm._v("Aprobar")]], 2), _c('strong', [_vm._v("Al aprobar, se crearan los permisos y no se podrán hacer cambios.")])])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazar = false
      },
      "do": _vm.rechazar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazarMasiva) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazarMasiva",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazarMasiva = false
      },
      "do": _vm.rechazarMasivo
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar masivamente?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionAprobarMasiva) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobarMasiva",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionAprobarMasiva = false
      },
      "do": _vm.aprobarMasivo
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea aprobar masivamente?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Aprobando...")] : [_vm._v("Aprobar")]], 2)])], 1) : _vm._e(), (_vm.isSeleccionMasiva) ? _c('div', {
    staticClass: "acciones display-flex aic jcc mb-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5",
    on: {
      "click": _vm.confirmarAprobarMasivo
    }
  }, [_vm._m(0), _c('span', [_vm._v("Aprobar")])]), _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": _vm.confirmarRechazoMasivo
    }
  }, [_vm._m(1), _c('span', [_vm._v("Rechazar")])])]) : _vm._e(), _c('div', {
    staticClass: "body"
  }, [_c('transition-group', {
    staticClass: "contenedor-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.isLoading) ? _c('loading', {
    key: "loading"
  }) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading && _vm.mostrarMensajeDeNoSolicitudes) ? _c('div', {
    key: "mensaje_no_solicitudes",
    staticClass: "mensaje-informacion"
  }, [_c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', [_vm._v("No hay solicitudes para aprobar")])])])]) : _vm._e(), _c('div', {
    key: "table-solicitud-por-aprobar",
    staticClass: "is-desktop"
  }, [(_vm.lista.length > 0) ? _c('table', {
    key: "table-solicitud-por-aprobar",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead'), _c('thead', [_c('th', [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "solicitud"
    },
    domProps: {
      "checked": _vm.seleccionadosTodos
    },
    on: {
      "change": function($event) {
        return _vm.check('all')
      }
    }
  })]), _c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Motivo")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index + o.id + '',
      staticClass: "row-table"
    }, [_c('td', {
      staticClass: "ta-center"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": o.id
      },
      domProps: {
        "checked": o.seleccionado
      },
      on: {
        "change": function($event) {
          return _vm.check(o)
        }
      }
    })]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_c('span', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])]), _c('td', [_vm._v(_vm._s(o.descripcionTipo))]), _c('td', [(o.motivo) ? [_c('span', [_vm._v(_vm._s(o.motivo))])] : [_c('span', [_vm._v("Sin motivo")])], _c('br'), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde === i.hasta ? i.desde : ((i.desde) + " - " + (i.hasta))) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2)], 2), _c('td', {
      staticClass: "text-center"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', [_vm._v("Sin adjunto")])], (!_vm.isSeleccionMasiva) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : _vm._e()], 2)])
  }), 0)], 1) : _vm._e()]), _c('div', {
    key: "mobile-solicitud-por-aprobar",
    staticClass: "is-mobile"
  }, [_vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": o.id
      },
      domProps: {
        "checked": o.seleccionado
      },
      on: {
        "change": function($event) {
          return _vm.check(o)
        }
      }
    })]), _c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_c('span', {
      staticClass: "is-bold hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])]), _c('div', {
      staticClass: "descripcion-tipo"
    }, [_c('span', [_vm._v(_vm._s(o.descripcionTipo))])]), _c('div', {
      staticClass: "motivo"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(o.motivo))])])]), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde === i.hasta ? i.desde : ((i.desde) + " - " + (i.hasta))) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2), _c('div', {
      staticClass: "botones"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : _vm._e(), (!_vm.isSeleccionMasiva) ? [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])] : _vm._e()], 2)])
  }), (_vm.isSeleccionMasiva) ? _c('div', {
    staticClass: "acciones display-flex aic jcc mb-10 mt-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5",
    on: {
      "click": _vm.confirmarAprobarMasivo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": _vm.confirmarRechazoMasivo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _c('span', [_vm._v("Rechazar")])])]) : _vm._e()], 2)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7833f592","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Permisos_Lista_Solicitudes_Por_Aprobar_RRHH.vue
// module id = 912
// module chunks = 0